module.exports = __webpack_public_path__ + "img/cxfq-xcb-icon-1@2x.9b086614.png";